<template>
<table class="emailtemplate" cellpadding="0" cellspacing="0" border="0" style="background-color: #ffffff; max-width:600px; display: block; padding-top: 20px" bgcolor="#ffffff">
<tbody>
  <tr width="600" style="display: block;">
  <td width="210"><a :href="mainFields[3].value" target="_blank"><img src="https://abbeyroadinstitute.com/wp-content/signatureimages/logo-updated.jpg" width="210" height="96" style="display: block; height: auto; " alt="Abbey Road Institute"></a>
    </td>
    <td width="390">
      <table  width="330" cellpadding="0" cellspacing="0" border="0" style="padding-left: 0px; font-family: Arial, sans-serif; font-size: 14px; color: #000000; line-height: 18px;">
        <tr>
          <td colspan="2" style="font-family: Arial, sans-serif; font-size: 14px; color: #000000; line-height: 18px;">
            <span style="color:#000000; font-size: 16px; font-weight: 700; text-transform: uppercase;">{{ mainFields[0].value }}</span><br>
            <span style="color:#000000; font-size: 15px; font-weight: 400; text-transform: uppercase;  padding-bottom: 10px; display: block;">{{ mainFields[1].value }}</span>
            <span style="color:#404040; font-size: 12px; font-weight: 400;">Abbey Road Institute - {{ mainFields[2].value }}<br></span>
            <a :href="'mailto:' + mainFields[4].value" style="text-decoration: none; color: #000000; font-size: 12px; font-weight: 600;">{{ mainFields[4].value }}</a><br>
            <a :href="'tel:' + mainFields[5].value" style="text-decoration: none; color: #000000; font-size: 12px; font-weight: 600;">{{ mainFields[5].value }}</a>
          </td>
        </tr>
      </table>
    </td>
  </tr>
  <tr width="600" style="display: block; height: 20px;">
  <tr style="display: block; max-width:600px; height: 10px; border-top: 1px solid #7d7d7d;">
  <tr width="600" style="display: block;">
  <td width="120">
              <a
              style="display: inline-block; font-size: 0;"
              v-for="item in socials.installed"
              :key="item.name"
              :href="formatLink(item.link)"
            >
              <span
                style="width: 20px; height:20px; display: inline-block; padding: 2px; border-radius: 3px; box-sizing: border-box; margin: 7px 5px 0 0;"
                :style="{
                  backgroundColor: 'transparent',
                  backgroundImage: `url(https://abbeyroadinstitute.com/wp-content/signatureimages/${item.icon}-updated.png)`,
                  backgroundPosition: 'center center',
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: '20px 20px',
                }"
              ></span>
            </a>
    </td>
    <td width="480">
      <table  max-width="480" cellpadding="0" cellspacing="0" border="0" style="padding-left: 0px; font-family: Arial, sans-serif; font-size: 14px; color: #000000; line-height: 18px;">
        <tr>
          <td colspan="2" style="font-family: Arial, sans-serif; font-size: 14px; color: #000000; line-height: 18px;">
            <span style="color:#000000; font-size: 12px; font-weight: 400; text-transform: uppercase;">Abbey Road Institute</span><span style="color:#000000; font-size: 12px; font-weight: 400; text-transform: uppercase;">&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;{{ mainFields[6].value }}</span><br>
          </td>
        </tr>
      </table>
    </td>
  </tr>
    <tr width="600" style="display: block; height: 10px;">

  <tr width="600" style="display: block;">

          <td colspan="2" style="font-family: Arial, sans-serif; font-size: 14px; color: #000000; line-height: 14px;">
            <span v-html="mainFields[7].value" style="color:#acacac; font-size: 10px;">{{ mainFields[7].value }}</span><br>
    </td>
  </tr>

</tbody>
</table>
</template>

<script>
import EmailTemplate from './emailTemplate'

export default {
  extends: EmailTemplate
}
</script>
